import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AttachmentDetailDto } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-attachment-preview[attachment]',
  templateUrl: './attachment-preview.component.html',
  styleUrls: ['./attachment-preview.component.scss'],
})
export class AttachmentPreviewComponent {

  @Input()
  attachment!: AttachmentDetailDto;

  @Input() size: 'tiny' | 'small' | 'medium' | 'large' | 'giant' = 'medium';

  @Input()
  isDisabled = false;

  @Input()
  selected = false;

  @Output()
  imageEditClick = new EventEmitter<void>();

  @Output()
  tagsEditClick = new EventEmitter<void>();

  getImage(attachment: AttachmentDetailDto): string {
    if (attachment.type === 'IMAGE') {
      return 'url("' + attachment.presignedUrl + '")';
    }
    return 'url("https://i.imgur.com/RBVnLkt.png")';
  }

  getFileName(attachment: AttachmentDetailDto): string {
    if (attachment.fileName && attachment.fileEnding) {
      return attachment.fileName + '.' + attachment.fileEnding;
    }
    return 'Kein Dateiname';
  }

  getTransform(): string {
    return `rotate(${this.attachment.rotationDegrees}deg)`;
  }

  createTagTooltip(): string {
    return `Tags: ${this.attachment.tags?.map(t => t.name).join(', ') ?? ''}`;
  }

  hasComment(): boolean {
    return !!this.attachment.comment?.length;
  }

  createCommentTooltip(): string {
    return `Kommentar: ${this.attachment.comment ?? ''}`;
  }

  hasTags(): boolean {
    return !!this.attachment.tags?.length;
  }

  editTagsClick(event: MouseEvent): void {
    event.stopPropagation();
    this.tagsEditClick.emit();
  }

  get sizePx(): string {
    switch (this.size) {
      case 'tiny':
        return '2rem';
      case 'small':
        return '4rem';
      case 'medium':
        return '8rem';
      case 'large':
        return '10rem';
      case 'giant':
        return '12rem';
    }
  }

}
